<template>
	<div class="view">
		<ArticleContainer>
			<header class="section">
				<div class="left">
					<div class="title">Личный опыт</div>
					<div
						class="text light"
					>Свою первую татуировку я сделал в двадцать четыре года. На руке у меня был набит биомеханический червь с женским лицом, а на бицепсе — браслет из колючек. Это были двухтысячные.
						<div class="line"></div>
					</div>
				</div>
				<div class="right"></div>
			</header>

			<div class="section one">
				<div class="inner">
					<div class="left">
						<img src="@/assets/article2/2.jpg">
					</div>
					<div class="right">
						<div class="subtitle">О первых татуировках</div>
						<div
							class="text light"
						>Свою первую татуировку я сделал в двадцать четыре года. На руке у меня был набит биомеханический червь с женским лицом, а на бицепсе — браслет из колючек. Это были двухтысячные. В то же время я учился делать татуировки и на курсах познакомился с парнем, который уехал из России на Кипр, но потом вернулся сюда за каким-то сертификатом. В общем, мы ушли с этих занятий, поехали к нему домой, и он мне подсунул на выбор две картинки. Одну из них он мне и набабахал. Утром я, конечно, офигел. А чуть позже с горем пополам сам себе перебил эту татуировку в того самого червя.</div>
					</div>
				</div>
			</div>

			<div class="section three"></div>

			<div class="section two">
				<div class="inner">
					<div
						class="text dark"
					>Вообще, тогда все проще относились к татуировкам. Это сейчас некоторые тренируются на бананах. Мы же набивали руку прямо на людях. Моим тренировочным клиентом стала моя сестра. Я набил ей на плече скорпиона в стиле трайбл. Получилась какая-то хрень. На бумаге я рисовал тогда гораздо лучше, чем на теле. Но потом, конечно, когда научился уже нормально колоть, перекрыл ей этот рисунок бабочкой с черными крыльями.</div>
					<div class="bottom">
						<div class="left">
							<div
								class="text light"
							>Моя первая настоящая клиентка уже принесла мне деньги. Трясущимися руками я наколол ей какой-то иероглиф и получил пятьсот рублей. У меня не было большого портфолио, и я врал, что уже давно занимаюсь татуировкой, иначе бы у меня не было ни одного клиента. Начиная с пятой работы я уже начал формировать портфолио. Хотя лажи много делал, конечно. По Москве много людей ходит с моими косяками.</div>
						</div>
						<div class="right">
							<img src="@/assets/article2/4.jpg">
						</div>
					</div>
				</div>
			</div>

			<div class="section four">
				<div class="inner">
					<div class="subtitle">О принципах</div>
					<div
						class="text light"
					>Я не буду делать татуировку человеку младше восемнадцати лет. У него организм еще формируется, еще двадцать раз поменяется структура тела, он вытянется. И даже если придет подросток, который внешне уже сформировался, с разрешением от родителей, все равно не возьмусь за работу. А если увижу, что человек не уверен или не готов сделать тату, то стану отговаривать. Еще на стадии приглашения на консультацию я выясняю у человека, есть ли в его голове какие-то тезисы, базовое видение. Когда говорят: «Я видел ваши работы, хочу что-то такое сделать», — это все, здесь заложена бомба замедленного действия. Значит, он мне мозг вынесет.</div>
					<img src="@/assets/article2/5.jpg">
				</div>
			</div>

			<div class="section qoute">
				<div class="inner">
					<uiDevider/>
					<div
						class="quote-text"
					>Мне интересно колоть то, что я рисую сам, а не то, что мне принесли из интернета. Я люблю добрые сюжеты. И люблю делать «рукава» — это самое красивое, что может быть в тату, особенно когда рисунок красиво вписан в мышцы. Красотища!</div>
					<uiDevider/>
				</div>
			</div>
		</ArticleContainer>
	</div>
</template>

<script>
import ArticleContainer from '@/components/ArticleContainer'

export default {
	components: {
		ArticleContainer
	},
}
</script>



<style lang="less" scoped>
@import "../styles.less";

.view {
	width: 100vw;
	height: 100vh;
	@media (max-width: 900px) {
		height: auto;
	}
}

.section {
	background: @color-main;
	color: #000;
}

.text {
	font-size: 16px;
	max-width: 500px;
	text-align: left;

	&.light {
		color: #fff;
	}

	&.dark {
		font-family: @font-title;
		font-size: 20px;
		font-weight: bold;
		line-height: 26px;
		text-transform: uppercase;
	}

	&.dark.big {
		font-size: 30px;
		line-height: 36px;
		text-transform: none;
	}
}

.subtitle {
	font-size: 20px;
	margin-bottom: 15px;
	text-align: left;
	font-weight: bold;
}

header {
	/deep/ .fp-tableCell {
		display: flex;
	}

	.left {
		width: 55vw;
		height: 100vh;
		background: @color-main;
		color: #000;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;

		.title {
			width: 100%;
			max-width: 500px;
			font-size: 60px;
			font-weight: bold;
			margin-bottom: 30px;
			text-transform: uppercase;
			font-family: @font-title;
			text-align: left;
		}

		.text {
			line-height: 30px;
			font-size: 18px;
		}

		.line {
			width: 2px;
			height: 50px;
			background: #fff;
			margin-top: 20px;
			transform-origin: top;
			animation: bounceAnim 1.2s linear infinite;
		}
	}

	.right {
		width: 45vw;
		height: 100vh;
		background-image: url("../assets/article2/1.jpg");
		background-size: cover;
		background-position: center top;
	}

	@keyframes bounceAnim {
		0%,
		100% {
			transform: scaleY(0.8);
		}
		50% {
			transform: scaleY(1);
		}
	}

	@media (max-width: 900px) {
		display: flex;
		flex-direction: column-reverse;

		.left {
			width: 100vw;
			max-width: 90%;
			height: auto;
			margin: 0 auto;

			.title {
				font-size: 30px;
				padding-top: 30px;
				margin-bottom: 20px;
			}

			.line {
				display: none;
			}
		}

		.right {
			width: 100vw;
			height: 60vh;
		}
	}
}

.qoute {
	.inner {
		width: 100%;
		max-width: 800px;
		margin: 0 auto;
	}
	.quote-text {
		text-align: center;
		font-size: 50px;
		font-family: @font-title;
		font-weight: bold;
		line-height: 48px;
		margin: 40px 0;
	}

	@media (max-width: 900px) {
		.inner {
			padding-top: 30px;
			padding-bottom: 30px;
		}

		.quote-text {
			width: 90%;
			margin: 30px auto;
			font-size: 36px;
			line-height: 40px;
		}
	}
}

.section.one {
	.inner {
		display: flex;
		flex-direction: row;
		justify-content: center;
		align-items: center;
	}

	.text {
		margin-bottom: 30px;
	}

	.left {
		margin-right: 60px;
	}

	@media (max-width: 900px) {
		.inner {
			flex-direction: column;
			width: 90%;
			margin: 0 auto;
		}

		.left {
			margin: 0;
			margin-bottom: 30px;
			margin-top: 30px;

			img {
				width: 100%;
			}
		}
	}
}

.section.two {
	.inner {
		margin: 0 auto;
		max-width: 900px;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
	}

	.subtitle {
		width: 100%;
		text-align: left;
	}

	.text {
		max-width: 100%;
	}

	.bottom {
		display: flex;
		margin-top: 50px;

		.right {
			margin-left: 50px;
		}
	}

	@media (max-width: 900px) {
		.inner {
			flex-direction: column;
			width: 90%;
			margin: 0 auto;
			padding-top: 30px;
		}

		.bottom {
			flex-direction: column-reverse;
			margin: 30px 0;

			.right {
				margin: 0;
				margin-bottom: 30px;
				img {
					width: 100%;
				}
			}
		}
	}
}

.section.three {
	background-size: cover;
	background-image: url(../assets/article2/3.jpg);

	@media (max-width: 900px) {
		width: 100vw;
		height: 60vh;
		background-position: center;
	}
}

.section.four {
	.inner {
		max-width: 820px;
		// display: flex;
		// justify-content: center;
		// align-items: center;
		margin: 0 auto;
	}

	.text {
		max-width: 820px;
	}

	img {
		width: 100%;
		margin-top: 50px;
	}

	@media (max-width: 900px) {
		.inner {
			width: 90%;
			margin: 0px auto;
			padding: 30px 0;
			flex-direction: column;
		}

		.text {
			font-size: 24px;
			line-height: 30px;
		}

		img {
			width: 100%;
			margin: 0;
			margin-top: 30px;
		}
	}
}

.section.five {
	.inner {
		margin: 0 auto;
		max-width: 780px;
	}

	.text {
		max-width: 100%;
		text-align: center;
	}

	.text.light {
		margin-bottom: 50px;
	}

	img {
		margin: 30px auto;
	}

	@media (max-width: 900px) {
		.inner {
			width: 90%;
			margin: 0px auto;
			padding: 30px 0;
			flex-direction: column;
		}
	}
}
</style>
